var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44995 7.12166L9.20846 6.36387L13.3399 10.4939C13.4065 10.56 13.4593 10.6387 13.4954 10.7254C13.5315 10.8121 13.55 10.905 13.55 10.9989C13.55 11.0928 13.5315 11.1858 13.4954 11.2725C13.4593 11.3591 13.4065 11.4378 13.3399 11.504L9.20846 15.6361L8.45067 14.8783L12.3283 11L8.44995 7.12166Z",
    fill: "#202020"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderRightArrow);
export default __webpack_public_path__ + "static/media/slider-right-arrow.a4be6e948e75b25b7dbeccc18771cb05.svg";
export { ForwardRef as ReactComponent };